<template lang="pug">
    button(
        ref="_in",
        type="button",
        class="_btn",
        :class="{ [tone]: tone, outline: !ivalue }",
        :id="id",
        :disabled="disabled",
        :inert="inert",
        :tabindex="inert ? -1 : tabindex",
        v-on="__on")
        slot &#xfeff;
</template>

<script>
    import button from './ib-button.vue'
    import entry from '../form/ib-form-entry.vue';

    /**
     * A form control that emits a boolean value and appears as a button with solid style if true,
     * outline style if false.
     */
    export default {
        name: 'ib-button-toggle',

        mixins: [
            button,
            entry
        ],

        methods: {
            _click() {
                this._emit(!this.ivalue);
                this.$emit('change');
            }
        }
    }
</script>

<docs>
    Basic Example:
    ```jsx
        new Vue({
            data() {
                return {
                    state: true
                }
            },
            template:
            `<ib-context>
                <ib-button-toggle v-model="state" class="accent">Toggle Me!</ib-button-toggle>
            </ib-context>`
        });
    ```
</docs>
